<script lang="ts">
	import type { TripOptions } from '$lib/components/search/itinerary/tripOptionsStore';
	import type { WayPoint } from '$lib/components/search/itinerary/types';
	import type { PageData } from './$types';
	import { browser } from '$app/environment';
	import Footer from '$lib/components/footer/Footer.svelte';
	import ItinerarySearchPanel from '$lib/components/itinerary/ItinerarySearchPanel.svelte';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import {
		getSearchParamsStore,
		gotoWithParams,
		type SearchParams,
	} from '$lib/services/urls/searchParams';
	import { onMount } from 'svelte';

	const mapLayoutContext = getMapLayoutContext();
	const { mapCenter, itineraryStore, tripOptionsStore } = mapLayoutContext ?? {};
	const { itinerary } = itineraryStore;

	const searchParams = getSearchParamsStore();

	export let data: PageData;
	$: ({ itineraryResultsStore, seoDataStore, partnersLinks } = data);
	$: seo = $seoDataStore;

	let isMounted = false;
	let searchActive = false;
	$: isSearchActiveOnMobile = searchActive && browser && $isMobile;

	/**
	 * Reset the itinerary results
	 * Useful when the user goes back to the iti search page in which case
	 * we want to remove the iti result polylines from the map
	 */
	function resetItineraryResults(
		_itineraryStore: WayPoint[],
		_searchParams: SearchParams,
		_tripOptions: TripOptions,
	) {
		if (isMounted && $itineraryResultsStore.routes.length > 0) {
			itineraryResultsStore.reset();
		}
	}

	onMount(() => {
		isMounted = true;
	});

	// Reset the itinerary results when the itinerary changes
	$: resetItineraryResults($itinerary, $searchParams, $tripOptionsStore);

	function handleClose(toTrackBackHome: boolean) {
		if (toTrackBackHome) {
			track({
				action: 'back_to_homepage',
				payload: {
					action: 'click',
				},
			});
		}

		gotoWithParams(`/map`, $searchParams);
	}
</script>

<div class="fixed md:relative top-0 h-full w-full">
	<div class="flex flex-col h-full w-full lt-md:overflow-auto bg-neutral-weakest md:py-2">
		<div class="relative flex flex-col gap-2 md:gap-4">
			<ItinerarySearchPanel
				{itineraryStore}
				isItineraryAlreadyComputed={$itineraryResultsStore.routes.length > 0
					|| typeof $searchParams.selectedRoute === 'number'}
				proximity={$mapCenter}
				onClose={({ toTrackBackHome }) => handleClose(toTrackBackHome)}
				bind:active={searchActive}
				{isSearchActiveOnMobile}
			/>
		</div>
		{#if !isSearchActiveOnMobile}
			<Footer {seo} {partnersLinks} />
		{/if}
	</div>
</div>
